export const GET_TABLE_DATA = 'GET_TABLE_DATA'
export const SALES_METRIC_CONTACTS = 'SALES_METRIC_CONTACTS'
export const CLEAR_SALES_METRIC_CONTACTS = 'CLEAR_SALES_METRIC_CONTACTS'
export const SALES_METRIC_ACTIVITIES = 'SALES_METRIC_ACTIVITIES'
export const CLEAR_SALES_METRIC_ACTIVITIES = 'CLEAR_SALES_METRIC_ACTIVITIES'
export const GET_SALES_METRIC_PDF_DATA = 'GET_SALES_METRIC_PDF_DATA'
export const CLEAR_SALES_METRIC_PDF_DATA = 'CLEAR_SALES_METRIC_PDF_DATA'
export const SALES_METRIC_LOADING = 'SALES_METRIC_LOADING'
